import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from "vue";
import { SimpleTableauServerAlertDTO } from "../common/api/autogenerated";


export default /*#__PURE__*/_defineComponent({
  __name: 'ServerAlert',
  props: {
    info: { type: Object, required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;


const alert = ref<Element | null>(null);

// onMounted(() => {
//     const root = alert.value?.parentElement as HTMLElement;
//     if (!root) {
//         return;
//     }
//     root.id = props.info.id;
//     root.setAttribute('class', 'hidden');
// });

const __returned__ = { props, alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})